
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import FlexibleContent from '@/templates/flexible-content';
import Post from '@/templates/post';
import config from '@/config';
import i18n from '@/i18n';
import { getLayout } from '@/components/Layout';
import { getCommonData } from '@/graphql/api';
import { getAllRoutes } from '@/graphql/api/getAllRoutes';
import { client } from '@/graphql/client';
import { getPost } from '@/graphql/queries';
import { postTransformer } from '@/graphql/transformer/postTransformer';
import { errorGrahpQL, getWordpressPath } from '@/graphql/utils';
import { sectionTransformer } from '@/lib/graphql/transformer/sections';
import type { TypeFlexibleContent } from '@/lib/graphql/transformer/sections';
import type { TypePostProps } from '@/templates/post';
import type { GetStaticProps } from 'next';
import type { AppCommonProps } from 'pages/_app';
type PageProps = {
    flexibleContent: TypeFlexibleContent[];
    post: TypePostProps;
};
export const PostPage = ({ flexibleContent, post }: PageProps) => (<>
    <Post {...post}/>
    <FlexibleContent flexibleContent={flexibleContent}/>
  </>);
const getStaticProps: GetStaticProps<PageProps & AppCommonProps> = async ({ locale, params }) => {
    const { uri } = params || {};
    const postPage = await client.query({
        query: getPost,
        variables: {
            slug: getWordpressPath({
                slug: uri,
                locale: locale ?? i18n.defaultLocale,
                path: '/blog',
            }),
        },
    });
    const data = postPage?.data?.post;
    errorGrahpQL(postPage);
    if (!data || !data.language.locale.includes(locale))
        return { notFound: true };
    const { contenidoFlexible: { contenido: flexibleContentData = [] }, seo, ...postData } = data;
    const databaseId = data?.contenido?.edificio?.databaseId;
    const post = postTransformer(postData);
    const province = data?.contenido?.province;
    const flexibleContent = await sectionTransformer({
        flexibleContent: flexibleContentData,
        building: null,
        locale: locale ?? i18n.defaultLocale,
        buildingId: databaseId,
        province,
    });
    const { footer, header } = await getCommonData({
        locale: locale ?? i18n.defaultLocale,
        content: null,
        translations: data.translations,
    });
    return {
        props: {
            seo,
            flexibleContent,
            header,
            footer,
            post,
        },
        revalidate: config.revalidate,
        notFound: !data,
    };
};
export const getStaticPaths = async () => ({
    paths: await getAllRoutes({ type: 'posts' }),
    fallback: 'blocking',
});
PostPage.getLayout = getLayout;
export default PostPage;

    async function __Next_Translate__getStaticProps__19d97041d7a__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/[uri]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19d97041d7a__ as getStaticProps }
  